import { Component, DestroyRef, inject, Injectable, signal } from '@angular/core';


export interface Toast { id?: number; title: string; description?: string; }

@Injectable({ providedIn: 'root' })
export class ToastService {
  private items = signal<Toast[]>([]);
  private seq = 0;
  list = this.items.asReadonly();

  show(t: Toast) {
    const id = ++this.seq;
    this.items.update(arr => [...arr, { ...t, id }]);
    // Auto-dismiss after 3.5s
    setTimeout(() => this.dismiss(id), 3500);
  }
  dismiss(id: number) { this.items.update(arr => arr.filter(t => t.id !== id)); }
}

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [],
  template: `
    <div class="fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2 px-4">
      @for (t of service.list(); track t.id) {
        <div class="w-full max-w-sm rounded-md border border-gray-200 bg-white p-3 shadow-lg dark:border-gray-800 dark:bg-gray-950">
          <div class="flex items-start justify-between gap-3">
            <div>
              <div class="font-medium">{{ t.title }}</div>
              @if (t.description) {
                <div class="text-sm text-gray-600 dark:text-gray-300">{{ t.description }}</div>
              }
            </div>
            <button class="rounded-md border px-2 py-1 text-xs dark:border-gray-700" (click)="service.dismiss(t.id!)">Schließen</button>
          </div>
        </div>
      }
    </div>
    `,
})
export class ToastContainerComponent {
  service = inject(ToastService);
}
